import OpenAI from "openai"
import { isBrowser } from "@/lib/agents/isbrowser"
import { documentContentExtractionPrompt } from './prompts'
import { chunkText, extractLocaleAndText, uploadFile } from "./utils"

export async function extractDoc(file: File, apiKey: string) {

  const client = new OpenAI({ apiKey, dangerouslyAllowBrowser: true, baseURL: isBrowser ? "https://signpost-ia-app-qa.azurewebsites.net/decorsify/https://api.openai.com/v1" : undefined })
  const fileu = await uploadFile(file, client, "user_data")

  console.log("Calling OpenAI...")
  const response = await client.responses.create({
    model: "gpt-5-nano",
    input: [
      {
        role: "user",
        content: [
          {
            type: "input_file",
            file_id: fileu.id,
          },
          {
            type: "input_text",
            text: documentContentExtractionPrompt,
          },
        ],
      },
    ],
  })

  console.log("Received response from OpenAI.")

  await client.files.delete(fileu.id)

  const ext = extractLocaleAndText(response.output_text || "")
  ext.chunks = await chunkText(ext.text)
  return ext

}

